// The actual function
/**
 *
 * @param arg The argument to pipe
 * @param fns functions that have their argument types declared (Does not infer)
 * @returns
 */
export default function pipe(arg, ...fns) {
    if (arg === null) {
        return arg;
    }
    const ret = fns.reduce((acc, fn) => fn(acc), arg);
    return ret;
}
/* eslint-enable @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-return */
//# sourceMappingURL=pipe.js.map